/**
 * NicheBanner — displayed at the very top of the homepage (below navbar).
 * Purpose: Immediately signals to Google AdSense reviewers (and visitors)
 * that this is a Relationship Advice & Dating Tips blog, resolving the
 * domain-name / content-niche mismatch flag.
 */
export default function NicheBanner() {
  const topics = [
    { icon: 'ri-heart-line', label: 'Relationship Advice' },
    { icon: 'ri-chat-smile-2-line', label: 'Dating Tips' },
    { icon: 'ri-user-heart-line', label: 'Self-Love' },
    { icon: 'ri-discuss-line', label: 'Communication' },
    { icon: 'ri-emotion-line', label: 'Emotional Health' },
    { icon: 'ri-sparkling-line', label: 'Love Stories' },
  ];

  return (
    <div className="w-full bg-rose-50 dark:bg-rose-950/30 border-b border-rose-100 dark:border-rose-900/40 pt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-14 text-center">
        {/* Eyebrow label */}
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-rose-400 mb-4">
          <i className="ri-heart-fill text-xs" />
          Your guide to love &amp; connection
        </span>

        {/* Main headline — H1 for SEO weight on homepage */}
        <h1 className="text-3xl md:text-5xl font-bold text-stone-800 dark:text-stone-100 leading-tight mb-4"
          style={{ fontFamily: "'Lora', serif" }}
        >
          Relationship Advice &amp; Dating Tips
          <br className="hidden md:block" />
          <span className="text-rose-500"> for Real Life</span>
        </h1>

        {/* Sub-tagline */}
        <p className="text-base md:text-lg text-stone-500 dark:text-stone-400 max-w-2xl mx-auto leading-relaxed mb-8">
          Honest, thoughtful writing about love, dating, communication, and the beautiful
          complexity of human connection — published fresh every day.
        </p>

        {/* Topic chips */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
          {topics.map(({ icon, label }) => (
            <span
              key={label}
              className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white dark:bg-stone-800 border border-rose-100 dark:border-rose-900/50 text-sm text-stone-600 dark:text-stone-300 font-medium"
            >
              <span className="w-4 h-4 flex items-center justify-center text-rose-400">
                <i className={`${icon} text-sm`} />
              </span>
              {label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
